"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var em_1 = tslib_1.__importDefault(require("polished/lib/helpers/em"));

var react_1 = tslib_1.__importDefault(require("react"));

var getProp_1 = tslib_1.__importDefault(require("sportnet-utilities/lib/getProp"));

var styled_components_1 = tslib_1.__importStar(require("../../../theme/styled-components"));

var _utilities_1 = require("../../../utilities");

var AbsolutePositioner_1 = tslib_1.__importDefault(require("../../components/AbsolutePositioner"));

var Desc = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  ", ";\n  text-align: center;\n  width: 100%;\n  ", "\n"], ["\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  ", ";\n  text-align: center;\n  width: 100%;\n  ", "\n"])), em_1["default"](12), em_1["default"](20), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor && styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), utilities_1.emphasizeColor(0.35, theme.app.textColor, true));
}, function (_a) {
  var fullscreen = _a.fullscreen,
      theme = _a.theme;
  return fullscreen && styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      padding: 0 ", "px;\n    "], ["\n      padding: 0 ", "px;\n    "])), theme.app.padding);
});
var ImageWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  text-align: center;\n"], ["\n  position: relative;\n  width: 100%;\n  text-align: center;\n"])));
var ImageContainer = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var FullWidthMediaManagerImage = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var fullscreen = _a.fullscreen;
  return fullscreen && styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
});

var WidgetPhoto = function (props) {
  var _a;

  var theme = props.theme,
      renderEmpty = props.renderEmpty;
  var fullscreen = ((_a = props.data) === null || _a === void 0 ? void 0 : _a.fullscreen) || false;
  var description = '';
  var author = '';
  var source = '';
  var name = '';
  var picture = {};
  var uri = getProp_1["default"](props, ['data', 'uri'], '');

  if (uri) {
    // old format for photos
    var data = getProp_1["default"](props, ['data'], {});
    description = data.description;
    author = data.author;
    source = data.source;
    name = data.name;
    picture = data;
  } else {
    var data = getProp_1["default"](props, ['data', 'picture'], {});
    description = data.description;
    author = data.author;
    source = data.source;
    name = data.name;
    picture = data;
  }

  var textArray = [];

  if (author) {
    textArray = ["autor: " + author];
  }

  if (source) {
    textArray = tslib_1.__spreadArrays(textArray, ["zdroj: " + source]);
  }

  if (name) {
    textArray = tslib_1.__spreadArrays(textArray, [name]);
  }

  var getNaturalWidth = function () {
    if (fullscreen) {
      return 1920;
    }

    return _utilities_1.getMaxContentWidthFromTheme(theme);
  };

  if (!picture.media_url && !picture.uri && renderEmpty) {
    return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('photo'));
  }

  var content = react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(ImageWrapper, null, react_1["default"].createElement(FullWidthMediaManagerImage, {
    picture: picture,
    naturalWidth: getNaturalWidth(),
    naturalHeight: 0,
    fullscreen: fullscreen
  })), !!(description || textArray.length !== 0) && react_1["default"].createElement(Desc, {
    fullscreen: fullscreen
  }, description && description, react_1["default"].createElement("br", null), textArray.length !== 0 && textArray.join(', ')));

  if (fullscreen) {
    return react_1["default"].createElement(AbsolutePositioner_1["default"], null, content);
  }

  return content;
};

exports["default"] = styled_components_1.withTheme(react_1["default"].memo(WidgetPhoto));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;